// Product entitlement keys (the product-level authorization signal). Entitlements
// are derived from purchases and stored in sso.product_entitlements; requireEntitlement
// reads them. Keys are intentionally product-agnostic strings so new products can
// add entitlements without a code change.

export const Entitlements = {
  AggregateQueries: 'aggregate_queries',
  RawExport: 'raw_export',
  EmailSending: 'email_sending',
  QueryLimit: 'query_limit',
  ExportLimit: 'export_limit',
  Seats: 'seats',
  ApiAccess: 'api_access',
} as const;

export type Entitlement = (typeof Entitlements)[keyof typeof Entitlements];

export const PRODUCT_KEYS = {
  TipsData: 'tipsdata',
  DatabaseEmailer: 'databaseemailer',
  TipsOutreach: 'tipsoutreach',
  TipsVerify: 'tipsverify',
  TipsConnect: 'tipsconnect',
  TipsCockpit: 'tipscockpit',
  TipsPlatform: 'tips-platform',
} as const;

export type ProductKey = (typeof PRODUCT_KEYS)[keyof typeof PRODUCT_KEYS];
